module.exports = __webpack_public_path__ + "static/media/tipja.b97abd46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/tipja.png
// module id = 448
// module chunks = 0